import React, { useState, useCallback } from 'react';
import { Grid, Box } from '@mui/material';
import { useSelector } from 'react-redux';

import DetailTemplate from '../../components/common/template/DetailTemplate';
import DashboardTemplate from '../../components/dashboard/DashboardTemplate';
import DashboardApprovalContainer from './approval/DashboardApprovalContainer';
import DashboardCalendarContainer from './calendar/DashboardCalendarContainer';
import NoticeTemplate from '../../components/dashboard/notice/NoticeTemplate';
import SalesActivityContainer from '../salesMng/SalesActivityContainer';

const DashboardContainer = () => {
  const [calFullTyp, setCalFullTyp] = useState(false);
  const [appLineToggle, setAppLineToggle] = useState(false);
  const { user } = useSelector(({ auth }) => ({
    user: auth.user, //user정보
  }));

  const handleAppLineToggle = () => {
    setAppLineToggle(!appLineToggle);
  };

 

     const [isCalFull, setIsCalFull] = useState(false);

    // 🚀 2. 안쪽 버튼을 눌렀을 때 상태를 스위칭해 줄 함수 정의 (축소 시 전체 리렌더링 유도)
    const toggleCalFull = () => {
        setIsCalFull(prev => !prev);
    };
    
  return calFullTyp ? (
    <DashboardTemplate user={user}>
      <DetailTemplate title="스케줄 관리">
        <DashboardCalendarContainer toggleCalFull={toggleCalFull} full />
      </DetailTemplate>
    </DashboardTemplate>
  ) : (
    <DashboardTemplate user={user}>
      <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
        >
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={isCalFull ? 0 : 1} // 💡 확장 시 그리드 간격 제거
            >
                <Grid item xs={12} md={isCalFull ? 12 : 8} style={{ width: '100%' }}>
                    <DetailTemplate title="스케줄 관리">
                        <SalesActivityContainer toggleCalFull={toggleCalFull} isCalFull={isCalFull} />
                    </DetailTemplate>
                </Grid>
                {!isCalFull && (
                    <Grid 
                        item 
                        md={4} 
                        sx={{ 
                            display: { xs: 'none', md: 'block' } 
                        }}
                    >
                        <DetailTemplate title="공지사항">
                            <NoticeTemplate />
                        </DetailTemplate>
                    </Grid>
                )}
            </Grid>
        </Grid>

      <DetailTemplate title="내 결재함">
        <DashboardApprovalContainer />
      </DetailTemplate>

      {/* <DetailTemplate title="결재선 관리">
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
          <Button variant="outlined" onClick={handleAppLineToggle}>결제선 {appLineToggle ? `추가 닫기` : `추가`}</Button>
        </Box>
        <ApprovalListContainer />
        {appLineToggle && (
          <ApprovalFormContainer />
        )}
      </DetailTemplate>
      <DetailTemplate title="프로젝트 리스트">
        <ProjectListContainer pageUrl={projectPageUrl} />
      </DetailTemplate>
      <DetailTemplate title="유지보수 리스트">
        <MaintanceListContainer pageUrl={maintancePageUrl} />
      </DetailTemplate>
      <DetailTemplate title="세금계산서 리스트">
        <TaxbillListContainer />
      </DetailTemplate> */}
      {/* <DetailTemplate title="스케줄 확인">
      <DashboardCalendarContainer />
    </DetailTemplate> */}
    </DashboardTemplate>
  );
};

export default DashboardContainer;
